import React, { useEffect, useState } from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { activeModalType, ModalType } from '../state/modals';
import { valuationGlobalId } from '../state/openValuation';
import { modalEditorOpen } from '../state/modals';
import { getValuations } from '../services/fosService';
import { FOSTable } from '../common/table/FOSTable';
import { FOSTableDateCell } from '../common/table/FOSTableDateCell';
import { FOSTableTooltipCell } from '../common/table/FOSTableTooltipCell';
import { FOSTableVesselLinkCell } from '../common/table/FOSTableVesselLinkCell';
import { FOSTableCurrencyCell } from '../common/table/FOSTableCurrencyCell';
import { NumericFormat } from 'react-number-format';
import { ValuationCellInUSD } from '../Search/Valuation/ValutionCellInUSD';
export const RecentValuations = (props: any) => {
  const [sales, setSales] = useState<any>([]);

  const setSaleGlobalId = useSetRecoilState(valuationGlobalId);
  const [moodalOpen, setModalOpen] = useRecoilState(modalEditorOpen);
  const setModalType = useSetRecoilState(activeModalType);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [sortBy, setSortBy] = useState({ id: 'id', desc: true });

  const openSale = (saleGlobalId: string) => {
    setSaleGlobalId(saleGlobalId);
    setModalOpen(true);
    setModalType(ModalType.OpenValuation);
  };

  useEffect(() => {
    if (moodalOpen) {
      return;
    }

    getValuations(page, perPage, sortBy).then(
      (res) => {
        setSales(res.data);
        setTotalPages(res.pagination.lastPage);
      },
      (reason) => {
        console.log('ERROR');
      }
    );
  }, [page, perPage, moodalOpen, sortBy]);

  const columns = React.useMemo(
    () => [
      {
        Header: 'Effective Date',
        accessor: 'effective_date',
        Cell: (cell: any) => (
          <FOSTableDateCell value={cell.value}></FOSTableDateCell>
        ),
      },
      {
        Header: 'Vessel Type',
        accessor: 'vessel_type',
      },
      {
        Header: 'Vessel Name',
        accessor: 'vessel_name',
        Cell: ({ row }: any) => (
          <FOSTableVesselLinkCell
            imo={row.original.imo}
            vesselName={row.original.vessel_name}
          ></FOSTableVesselLinkCell>
        ),
      },
      {
        Header: 'Vessel Design',
        accessor: 'design',
      },
      {
        Header: 'Price Range Local',
        accessor: 'price_local_from',
        disableSortBy: true,
        Cell: ({ row }: any) => (
          <div>
            {row.original.currency}
            <span style={{ paddingLeft: '5px' }}>
              <NumericFormat
                value={row.original.price_local_from}
                displayType={'text'}
                thousandSeparator={true}
                decimalScale={2}
              />
              -
              <NumericFormat
                value={row.original.price_local_to}
                displayType={'text'}
                thousandSeparator={true}
                decimalScale={2}
              />
            </span>
          </div>
        ),
      },
      {
        Header: 'Price Range USD',
        accessor: 'price_usd_from',
        disableSortBy: true,
        Cell: ValuationCellInUSD,
      },

      {
        Header: 'Comments',
        accessor: 'comments',
        Cell: (cell: any) => (
          <FOSTableTooltipCell value={cell.value}></FOSTableTooltipCell>
        ),
      },
      {
        Header: 'Contact Price With Currency',
        accessor: 'contract_price',
        disableSortBy: true,
        Cell: ({ cell, row }: any) => (
          <FOSTableCurrencyCell
            value={row.original.contract_price}
            currency={row.original.contract_price_currency}
          ></FOSTableCurrencyCell>
        ),
      },
      {
        Header: 'Client',
        accessor: 'client',
      },
      {
        Header: 'Edit',
        Cell: (original: any) => {
          return (
            <button
              className='btn btn-sm btn-dark'
              onClick={(e) => {
                openSale(original.row.original.id);
                console.log('opening', original.row.original.id);
              }}
            >
              Edit
            </button>
          );
        },
      },
    ],
    []
  );

  return (
    <div>
      <div className='north-sea-spot-caption'>Recent Valuations</div>

      <div style={{ marginTop: '20px' }}>
        <FOSTable
          columns={columns}
          data={sales}
          setPage={setPage}
          setPerPage={setPerPage}
          currentpage={page}
          perPage={perPage}
          totalPage={totalPages}
          initialSortBy={sortBy}
          onChangeSort={setSortBy}
        ></FOSTable>
      </div>
    </div>
  );
};
